export default __webpack_public_path__ + "static/pixea-example6-8d3090e90b7d7efd608c782918b606fc.png";